import React, { useRef, 
  useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { useQuery, gql } from '@apollo/client'
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import {FaUserCircle} from 'react-icons/fa'

import { useLocation, useRouteMatch } from 'react-router-dom'
import { useIntl, FormattedMessage } from "react-intl";

import {
  Button, DropdownToggle,
  Container, 
  Row, 
  Col,
  Input, InputGroup, InputGroupPrepend,
  Link,
} from './StyledComponents.js';
import LoginModal from './components/LoginModal'
import SignupModal from './components/SignupModal'
import ForgotPasswordModal from './components/ForgotPasswordModal'
import {loggedInContext} from './auth/AuthContext'
import useWindowSize from './useWindowSize'
import useTenant from './client/useTenant'
import {useCsEvent} from './client/useEvents'
import HamburgerMenu from './components/HamburgerMenu';

const queryString = require('query-string')

const HeaderDiv = styled(Row)`
  display: flex;
  align-items: center;
  width: 100%;

  @media (min-width: 992px) {
    flex: 0 0 80.666667%;
    max-width: 80.666667%;
  }
`
const MenuVeLogo = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  @media (min-width: 576px) {
    flex: 0 0;
    max-width: 25%;
  }
`

const Logo = styled.nav`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
  text-align: center;
`  
const AramaCubugu = styled.div`
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  height: 45px;

  @media (min-width: 576px) {
      flex: 0 0 75%;
      max-width: 75%;
  }

  border-radius: 50rem;
  padding: .25rem;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
`
const AraField = styled(Input)`
  flex: 1 1;
`
const EkMenu = styled.div`
  @media (min-width: 992px) {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
    margin: 0 auto;
  }
  padding: 1rem;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
`
const Box = styled(Container)`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: rgb(246, 246, 246);
  box-shadow: 0 0.75px 4px rgba(0,0,0,.26);

  max-width: none;
  h1 {
    color: rgb(0,0,0);
  }
  p {
    color: rgb(0,0,0);
  }
  @media (min-width: 576px) {
    max-width: none;
  }
`
const LogoSpan = styled.span`
  font-size: 1rem;
  font-weight: bold;
`

const gqlQuery = gql`
  query Gazeteler {
    gazeteler {
      gazete,
      dil,
      gorunen_ad,
      logo
    }
  }
`
  
export function Header(props) {
  let location = useLocation()
  const history = useHistory()
  const windowSize = useWindowSize()
  const intl = useIntl()
  let match = useRouteMatch("/ara/:query")
  let { data } = useQuery(gqlQuery, {ssr: false}) 
  const {loggedIn, user, 
    isLoginOpen, isSignupOpen, 
    openLoginModal, openSignupModal, 
    closeAllModals} = React.useContext(loggedInContext) 
  const tenant = useTenant()
  const fireCsEvent = useCsEvent()

  const araInput = useRef();
  const setAraInput = useCallback(node => {
    console.debug("[Header] set ara input:", node, "match:", match);
    araInput.current = node;
    if(node) {
      node.value = match ? match.params.query : ""; 
    }
  }, [match]);
  const gazeteSelect = useRef();
  const setGazeteSelect = useCallback(node => {
    console.debug("[Header] set gazete select")
    gazeteSelect.current = node
    const queryParams = queryString.parse(location.search);
    if (queryParams.gazete && node) {
      node.value = queryParams.gazete;
    }
  }, [location.search])  
  const startDatePicker = useRef();
  const setStartDatePicker = useCallback(node => {
    console.debug("set start date picker");
    const queryParams = queryString.parse(location.search);
    startDatePicker.current = node;
    if (queryParams.startDate && node) {
      node.value = queryParams.startDate;
    }
  }, [location.search]);
  const endDatePicker = useRef();
  const setEndDatePicker = useCallback(node => {
    console.debug("set end date picker");
    const queryParams = queryString.parse(location.search);
    endDatePicker.current = node;
    if (queryParams.endDate && node) {
      node.value = queryParams.endDate;
    }
  }, [location.search]);
  const esnekAra = useRef();
  const setEsnekAra = useCallback(node => {
    console.debug("set esnek ara");
    const queryParams = queryString.parse(location.search);
    esnekAra.current = node
    if (queryParams.esnek && node) {
      node.checked = true;
    }
  }, [location.search]);
  const [isOpen, setIsOpen] = useState(false)
  const [showForgot, setShowForgot] = React.useState(false);

  console.debug("[Header] constructor match:", match, 
    "isOpen:", isOpen, 
    "logged in:", loggedIn
  )

  const ara = React.useCallback((e) => {
    if(e) e.preventDefault();
    console.debug("Ara form submitted araInput:", araInput.current)
    
    if(!araInput.current.value) return;

    fireCsEvent({
      category: 'Arama',
      action: 'Submit',
      label: 'Kullanıcı arama yapıyor'
    });

    let url = new URL(`/${tenant == "historyworm" ? "blockAra" : "ara"}/${araInput.current.value}`, 
      window.location.href)
    if (startDatePicker.current && startDatePicker.current.value) {
      url.searchParams.set("startDate", startDatePicker.current.value)
    } 
    if (endDatePicker.current && endDatePicker.current.value) {
      url.searchParams.set("endDate", endDatePicker.current.value)
    }
    if (esnekAra.current && esnekAra.current.checked) {
      url.searchParams.set("esnek", 't');
    }
    if (gazeteSelect.current && gazeteSelect.current.value) {
      url.searchParams.set("gazete", gazeteSelect.current.value)
    }
    history.push({pathname: url.pathname, search: url.search});
  }, [history])

  const toggleEkMenu = React.useCallback((e) => {
    if (!isOpen) {
      fireCsEvent({
        category: 'Arama',
        action: 'Engagement',
        label: 'Ek menü açıldı'
      });
    }
    e.preventDefault(); 
    setIsOpen(!isOpen);
  }, [isOpen])

  const onAccountClick = () => {
    fireCsEvent({
      category: "Header",
      action: "Engagement",
      label: "Account button click"
    })
    if (!loggedIn) {
      openLoginModal()
    } else {
      history.push("/account")
    }
  }

  const gazeteler = data?.gazeteler?.slice()?.sort((gazete1, gazete2) => {
    return gazete1.gorunen_ad > gazete2.gorunen_ad ? 1 : 
      gazete1.gorunen_ad < gazete2.gorunen_ad ? -1 : 0 
  })

  return (
    <>
      <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />
      <Box className="mb-2 pb-2" role="banner">
        {isLoginOpen && <LoginModal 
          onClose={() => closeAllModals()} onForgotPassword={() => {
            closeAllModals()
            fireCsEvent({
              category: 'Header',
              action: 'Engagement',
              label: 'Forgot password clicked'
            })
            setShowForgot(true)
          }} />}
        {isSignupOpen && <SignupModal onClose={() => closeAllModals()} />}
        <HeaderDiv>
          <MenuVeLogo>
            <Logo className="center-text">
              <Link to="/" rel="home" 
                onClick={() => {
                  fireCsEvent({
                    category: 'Header',
                    action: 'Navigation',
                    label: 'Logoya basıldı'
                  })
                }}>
                <LogoSpan className="m-1 mt-2">
                  <FormattedMessage id="name"/>
                </LogoSpan>
              </Link>
            </Logo>
            <HamburgerMenu
              loggedIn={loggedIn}
              user={user}
              openLoginModal={openLoginModal}
              openSignupModal={openSignupModal}
              closeAllModals={closeAllModals}
              onAccountClick={onAccountClick}
              windowWidth={windowSize.width}
            />
          </MenuVeLogo>
          <AramaCubugu className="bg-light mb-1">
            <form method="get" target="_top" action={process.env.REACT_APP_GA_BASE_URL+(tenant == "historyworm" ? "/blockAra" : "/ara")} 
                onSubmit={ara}> 
              <InputGroup>
                <InputGroupPrepend>
                  <Button id="button-search1" type="submit" className="btn btn-link text-warning">
                    <FontAwesomeIcon icon={faSearch} />
                  </Button>
                </InputGroupPrepend>
                <AraField type="search"
                  name="q"
                  ref={setAraInput}
                  placeholder={intl.formatMessage({id: "ara.cta", defaultMessage: "Gazetelerde arayın"})} 
                  aria-describedby="button-search1" 
                  className="border-0 bg-light" />
                <DropdownToggle onClick={toggleEkMenu}></DropdownToggle>
              </InputGroup>
            </form>
          </AramaCubugu>
        </HeaderDiv>
          
          {isOpen && (
            <EkMenu className="bg-light mt-1" style={{
              background: '#f8fafc',
              borderRadius: 16,
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              padding: '24px 20px 16px 20px',
              marginTop: 12,
              maxWidth: 600,
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 18
            }}>
              <div style={{ marginBottom: 8 }}>
                <p style={{ margin: 0, color: '#444', fontSize: 15 }}><FormattedMessage id="ara.aciklama" /></p>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18 }}>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <label htmlFor="gazete" style={{ fontWeight: 500, marginBottom: 6, display: 'block' }}>
                    <FormattedMessage id="ara.gazete" defaultMessage="Gazete:" />
                  </label>
                  <select id="gazete" name="Gazete" ref={setGazeteSelect}
                    style={{ width: '100%', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 15, padding: '6px 10px' }}>
                    <option value=""><FormattedMessage id="header.chooseOption" defaultMessage="--Please choose an option--" /></option>
                    {gazeteler?.map(gazete => (
                      <option value={gazete.gazete}>{gazete.gorunen_ad}</option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <label htmlFor="start" style={{ fontWeight: 500, marginBottom: 6, display: 'block' }}>
                    <FormattedMessage id="ara.fromDate" defaultMessage="Şu tarihten:" />
                  </label>
                  <Input type="date" id="start" ref={setStartDatePicker} name="Şu tarihten" min="1850-01-01"
                    style={{ width: '100%', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 15, padding: '6px 10px' }} />
                </div>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <label htmlFor="end" style={{ fontWeight: 500, marginBottom: 6, display: 'block' }}>
                    <FormattedMessage id="ara.endDate" defaultMessage="Şu tarihe:" />
                  </label>
                  <Input type="date" id="end" ref={setEndDatePicker} name="Şu tarihe" min="1850-01-01"
                    style={{ width: '100%', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 15, padding: '6px 10px' }} />
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginTop: 8 }}>
                <label htmlFor="esnek" style={{ fontWeight: 500, marginBottom: 0, display: 'block' }}>
                  <FormattedMessage id="header.flexibleSearch" defaultMessage="Esnek ara:" />
                </label>
                <Input type="checkbox" id="esnek" ref={setEsnekAra} name="esnek" style={{ marginLeft: 8, width: 18, height: 18 }} />
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 8, justifyContent: 'flex-end' }}>
                <Input type="button"
                  value={intl.formatMessage({ id: "ara.button", defaultMessage: "Ara" })} onClick={ara}
                  style={{ borderRadius: 8, background: '#1976d2', color: '#fff', border: 'none', fontWeight: 600, padding: '8px 22px', fontSize: 15, boxShadow: '0 1px 4px #e3f2fd' }} />
                <Input type="button" className="ml-1"
                  value={intl.formatMessage({ id: "ara.cancel", defaultMessage: "Boşver" })} onClick={toggleEkMenu}
                  style={{ borderRadius: 8, background: '#eee', color: '#333', border: 'none', fontWeight: 600, padding: '8px 22px', fontSize: 15 }} />
              </div>
            </EkMenu>
          )}
      </Box>
    </>
  );
}
